var _linearGradient, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketingServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ppm-marketing-service--lg-1",
    x1: 68.6663,
    x2: 544.1426,
    y1: 360.442,
    y2: 360.442,
    gradientTransform: "matrix(1 0 0 -1 0 596)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b17ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098aed"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41d3bd",
    d: "M460.4 329.9c43.7-75 86.9-150.2 130-225.4 11.2-19.4 12.9-40.3 3.3-60.8l-2.4-5.1c-.3-.6-.7-1.2-1-1.8C577.4 14.4 558.4 1.4 532.4.5c-23.2-.8-46.5-.3-69.8-.3-23.9 0-47.9-.1-71.8-.2-19.2 0-38.4-.1-57.6-.1-19.6 0-39.2.3-58.8.1-28.4-.3-50.5 11.1-64.8 36-43 74.4-85.9 148.9-128.8 223.4-9.3 16.3-11.6 33.7-7.7 52.4 2.1 4.4 4.2 8.9 6.3 13.3.9 1.5 1.8 3 2.7 4.6 12.7 21.2 31.6 33.2 56.3 33.9 25.9.8 51.7.2 77.7.2 31.8 0 63.7.1 95.6.1 28.4.1 56.9-.2 85.5.1 27.5.5 49.4-10.3 63.2-34.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#098aed",
    d: "M8.6 202.7l207.6 359.5c24.5 42.5 85.8 42.5 110.3 0l207.6-359.5C558.7 160.1 528 107 479 107H63.8c-49.1-.1-79.7 53.1-55.2 95.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ppm-marketing-service--lg-1)",
    d: "M479 107H168.6c-29.3 50.8-58.6 101.7-87.9 152.6-9.3 16.3-11.6 33.7-7.7 52.4 2.1 4.3 4 8.6 6.1 12.9l1.6 2.8 1.2 2.1c12.7 21.2 31.6 33.2 56.3 33.9 25.9.8 51.7.2 77.7.2 31.8 0 63.7.1 95.6.1 28.4.1 56.9-.2 85.5.1 27.6.2 49.4-10.6 63.3-34.3 25.3-43.5 50.5-87.1 75.6-130.7C557 157.3 526.7 107 479 107z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingServices);
export default __webpack_public_path__ + "static/media/marketing-services.680400c3.svg";
export { ForwardRef as ReactComponent };